import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Button from "@mui/material/Button";
import {
  Grid,
  MenuItem,
  FormControl,
  ListItemText,
  Select,
  Checkbox,
} from "@mui/material";
import moment from "moment";
import { RenderCellExpand } from "../../../../components/datagridtooltip/DataGridToolTip";
import Axios from "axios";
import { API_URL_LMS, API_URL_ADMIN,API_URL_USER } from "../../../../Constant/index";
import ExportExcelPopup from "../../../../components/exportPopup/ExportExcelPopup";
import {
  DataFormat,
  convertToCurrencyFormat,
} from "../../../../_helpers/commonFunctions";
import "./DealerAndSubdealerPoints.scss";
import DataGridProMUI from "../../../../components/DataGrid/DataGridProMUI";
import Controls from "./Controls";
import { useForm } from "../../../../components/Form/FormComponent";
import { onExportExcel } from "../../../../_helpers/exportExcel";
import { isPermission, authorizedMessage } from "../../../../_helpers/commonAPI";
import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },

  container: {
    maxHeight: "calc(90vh - 210px)",
  },

  paper: {
    width: "100%",
    marginBottom: theme.spacing(2),
  },
  table: {
    minWidth: 750,
  },
  visuallyHidden: {
    border: 0,
    clip: "rect(0 0 0 0)",
    height: 1,
    margin: -1,
    overflow: "hidden",
    padding: 0,
    position: "absolute",
    top: 20,
    width: 1,
  },
}));

const DealerAndSubdealerPoints = (props) => {
  const classes = useStyles();
  // OPTIONS FOR COMPANY

  const DATE_ONE_YEAR_BACK = new Date(
    new Date().setFullYear(new Date().getFullYear() - 1)
  );
  const INITIAL_STATE = {
    activityType: "",
    customerType: "",
    startDate: DATE_ONE_YEAR_BACK,
    endDate: new Date(),
    customerNumber: "",
    markDelete: [],
  };
  const names = ["Active", "Inactive"];
  // OPTIONS FOR CUSTOMER
  const CUSTOMER_LIST = ["Dealer", "Sub Dealer"];
  let [filterObj, setFilterObj] = useState(INITIAL_STATE);
  const [customerTypeErr, setCustomerTypeErr] = useState(false);
  const [customerNumber, setCustomerNumber] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [resetCount, setCount] = useState(0);
  const [filterErr, setFilterErr] = useState({});
  const [pageSize, setPageSize] = useState(25);
  const [gridData, setGridData] = useState([]);
  const [showLoading, setShowLoading] = useState(false);
  const [fileUrl, setFileUrl] = useState("");
  const [exportFiles, setExportFiles] = useState([]);
  const [open, setOpen] = useState(false);
  const [exportState, setExportState] = useState("Export");
  const [searchedRows, setSearchedRows] = useState(null)

  const clearAll = () => {
    setFilterObj(INITIAL_STATE);
    setCount((current) => current + 1);
    setFilteredData([]);
    setFilterErr({});
    setValues(INITIAL_STATE);
  };

  const CUSTOMER_NUMBER = "Customer Number";
  const filterOnChange = (e) => {
    setFilterErr({});
    setFilterObj({ ...filterObj, [e.target.name]: e.target.value });
  };

  const onExportClick = () => {
    const url = `export/dealerSubdealerPointsExport`;
    setExportState("Exporting...");
    let filters = {
      fromDate: filterObj.startDate
        ? moment(filterObj.startDate).format("DD-MM-YYYY")
        : null,
      toDate: filterObj.endDate
        ? moment(filterObj.endDate).format("DD-MM-YYYY")
        : null,
      isMarkDelete:
        filterObj.markDelete.length > 0 ? filterObj.markDelete.join(",") : null,
      customerType: filterObj.customerType ? filterObj.customerType : null,
      customerNumber: values.customerNumber ? values.customerNumber : null,
    };
    Axios({
      method: "POST",
      url: API_URL_LMS + url,
      data: filters,
      headers: {
        "Content-Type": "application/json",
        "X-AUTH-TOKEN": localStorage.getItem("x-auth-token"),
        "X-SOLD-TO-ID": localStorage.getItem("CustomerNumber"),
      },
    })
      .then(async (response) => {
        setExportState("Export");
        setOpen(true);
        setFileUrl(response.data.data);
        exportExcelFile(response.data.data);
      })
      .catch((err) => {
        setExportState("Export");
      });
  };

  function exportExcelFile(file_url) {
    setExportFiles([]);
    Axios({
      method: "GET",
      url: API_URL_LMS + `export/bucket?folderName=${file_url}`,
      headers: {
        "Content-Type": "application/json",
        "X-AUTH-TOKEN": localStorage.getItem("x-auth-token"),
        "X-SOLD-TO-ID": localStorage.getItem("CustomerNumber"),
      },
    })
      .then(async (response) => {
        const newRes = Array.isArray(response.data.data)
          ? response.data.data
          : [];
        setExportFiles(newRes);
      })
      .catch((err) => {
        // setExportState({ btnName: "EXPORT" });
      });
  }

  const validate = () => {
    let temp = {};
    if ("endDate" in filterObj && filterObj.endDate != null) {
      temp.startDate =
        filterObj.startDate > filterObj.endDate
          ? "Created Date From Should be lesser than Created Date To"
          : "";
    }
    setFilterErr({ ...temp });
    return Object.values(temp).every((eachFieldErr) => eachFieldErr == "");
  };

  // useform is a reusable component for forms
  // for single controll real time validation of form pass true as 2nd parameter and validate function as 3rd parameter
  const { values, setValues, handleInputChange, errors, setErrors } = useForm(
    INITIAL_STATE,
    true,
    validate
  );

  // This Function call on search button click
  const onFilterSearch = async() => {
    const isAllow = await isPermission("Master-LoyaltyReports-DealerandSubDealerPoints-view")
    if (!isAllow) {
        toast.success(authorizedMessage, {
            position: toast.POSITION.TOP_RIGHT
        });
        return 0;
    }

    if (validate()) {
      const requestOptions = {
        headers: {
          "Content-Type": "application/json",
          "X-AUTH-TOKEN": localStorage.getItem("x-auth-token"),
        },
      };
      setShowLoading(true);
      // /admin/dealerSubdealerPointsReport?customerType=Sub%20Dealer&fromDate=01-01-2022&isMarkDelete=false&toDate=31-12-2022%22
      Axios.get(
        API_URL_LMS +
          `/admin/dealerSubdealerPointsReport?fromDate=${
            filterObj.startDate
              ? moment(filterObj.startDate).format("DD-MM-YYYY")
              : null
          }&toDate=${
            filterObj.endDate
              ? moment(filterObj.endDate).format("DD-MM-YYYY")
              : null
          }&isMarkDelete=${
            !!filterObj.markDelete.length
              ? filterObj.markDelete.join(",")
              : null
          }&customerType=${
            filterObj.customerType ? filterObj.customerType : null
          }&customerNumber=${
            // filterObj.customerNumber ? filterObj.customerNumber : null
            values.customerNumber ? values.customerNumber : null
          }&isDealer=${false}&userId=${(
            localStorage.getItem('userData') && JSON.parse(localStorage.getItem('userData')).userId) ?
            JSON.parse(localStorage.getItem('userData')).userId : ''}&customer_number=${null}`,
        requestOptions
      )
        .then((response) => {
          setShowLoading(false);
          setFilteredData(
            response.data && response.data.data ? response.data.data : []
          );
        })
        .catch((error) => {
          setShowLoading(false);
          // setExportState({ btnName: "EXPORT" });
        });
    }
  };

  const MultipleSelectCheckmarks = () => {
    const [markDelete, setmarkDelete] = useState("");
    const handleChange = (event) => {
      const {
        target: { name, value },
      } = event;
      let selectedMenus = [...filterObj[name]];
      if (selectedMenus.findIndex((item) => item === value) > -1) {
        selectedMenus = selectedMenus.filter((item) => item !== value);
      } else {
        selectedMenus.push(value);
      }

      setFilterObj({ ...filterObj, [name]: [...selectedMenus] });
    };

    return (
      <div>
        <FormControl sx={{ minWidth: "100%" }}>
          <Select
            labelId="demo-multiple-checkbox-label"
            id="demo-multiple-checkbox"
            multiple={false}
            value={filterObj.markDelete}
            onChange={handleChange}
            input={<Controls.Select label="Mark Delete" />}
            renderValue={(selected) => selected.join(", ")}
            name={"markDelete"}
          >
            {/* <MenuItem value="">-Select-</MenuItem> */}
            {names.map((name) => (
              <MenuItem key={name} value={name}>
                {/* <Checkbox checked={filterObj.markDelete.indexOf(name) > -1} /> */}
                <ListItemText primary={name} />
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </div>
    );
  };

  // function for auto select that is pass into the AutoSelectSearch Components
  function autoSelectFn(selected, name) {
    setFilterObj({
      ...filterObj,
      [name]: selected && selected.value ? selected.value : "",
    });
    // setFilterObj({ ...filterObj, [selected.name]: selected.value });
  }

  const columns = [
    {
      field: "customerType",
      headerAlign: "center",
      align: "center",
      width: 150,
      headerName: "Type Of Customer",
    },
    {
      field: "companyGroup",
      headerAlign: "center",
      align: "center",
      width: 150,
      headerName: "Group Company",
    },
    {
      field: "salesDistrict",
      headerAlign: "center",
      align: "center",
      width: 150,
      headerName: "Sales District",
      // renderCell: RenderCellExpand,
    },
    {
      field: "customerNumber",
      headerAlign: "center",
      align: "center",
      width: 150,
      headerName: "Customer Number",
      renderCell: ({ row }) => {
        return (
          <div>{row.customerNumber ? DataFormat(row.customerNumber) : ""}</div>
        );
      },
    },
    {
      field: "customerNameEN",
      headerAlign: "center",
      align: "left",
      width: 190,
      headerName: "Customer Name (EN)",
      renderCell: RenderCellExpand,
    },
    {
      field: "customerNameTH",
      headerAlign: "center",
      align: "left",
      width: 190,
      headerName: "Customer Name (TH)",
      renderCell: RenderCellExpand,
    },
    {
      field: "totalPoints",
      headerAlign: "center",
      align: "right",
      width: 130,
      headerName: "Total Point",
      format: '#,##0.00',
      renderCell: ({ row }) => {
        return (
          <div>
            {row.totalPoints
              ? convertToCurrencyFormat(row.totalPoints)
              : convertToCurrencyFormat(0)}
          </div>
        );
      },
    },
    {
      field: "taxNumber",
      headerAlign: "center",
      align: "center",
      width: 150,
      headerName: "TAX Number",
    },
    {
      field: "markDelete",
      headerAlign: "center",
      align: "center",
      width: 150,
      headerName: "Mark Delete",
      renderCell: ({ row }) => {
        return (
          <div className="MarkDelChkBox">
            <Controls.Checkbox value={row.markDelete} />
          </div>
        );
      },
    },
    {
      field: "accountCreatedDate",
      headerAlign: "center",
      align: "center",
      width: 230,
      headerName: "Account Created Date",
      type: "date",
      format: 'DD-MM-yyyy',
      valueFormatter: (row) => {
        return row.value && row.value !== null
          ? moment(new Date(row.value)).format("DD-MM-yyyy")
          : "";
      },
    },
    {
      field: "lastPointsCreatedDate",
      headerAlign: "center",
      align: "center",
      width: 230,
      headerName: "Last Point Created Date",
      type: "date",
      valueFormatter: (row) => {
        let dd=row.value;
        let month = dd.getUTCMonth(); //months from 1-12
        let day = dd.getUTCDate();
        let year = dd.getUTCFullYear();
        // return row.value && row.value !== null
        //   ? moment(new Date(year, month, day)).format("DD-MM-yyyy")
        //   : "";
        return row.value && row.value !== null
          ? moment(new Date(row.value)).format("DD-MM-yyyy")
          : "";
      },
    },
    { field: 'aDate', headerName: 'aDate', hide: true },
    { field: 'lDate', headerName: 'lDate', hide: true },
    { field: 'p', headerName: 'point', hide: true },
  ];

  React.useEffect(() => {
    const gridData =
      filteredData &&
      filteredData.map((item, index) => {
        return {
          ...item,
          id:index,
          aDate:item.accountCreatedDate != null ? moment(new Date(item.accountCreatedDate)).format("DD-MM-yyyy"):"",
          lDate:item.lastPointsCreatedDate != null ? moment(new Date(item.lastPointsCreatedDate)).format("DD-MM-yyyy"):"",
          p:convertToCurrencyFormat(item.totalPoints.toString()),
          lastPointsCreatedDate:
            item.lastPointsCreatedDate != null
              ? new Date(item.lastPointsCreatedDate)
              : "",
          accountCreatedDate:
            item.accountCreatedDate != null
              ? new Date(item.accountCreatedDate)
              : "",
        };
      });
    setGridData(gridData);
  }, [filteredData]);

  const getCustomerNumber = (e) => {
    setCustomerTypeErr(false);
    if (filterObj.customerType === "") {
      setCustomerTypeErr(true);
    }
    if (filterObj.customerType === "Dealer" && e && e.length > 0) {
      getdealer(e);
    }
    if (filterObj.customerType === "Sub Dealer" && e && e.length > 0) {
      getSubdealer(e);
    }
  };

  const getdealer = (e) => {
    const requestOptions = {
      headers: {
        "Content-Type": "application/json",
        "X-AUTH-TOKEN": localStorage.getItem("x-auth-token"),
      },
    };
    Axios.get(
      API_URL_ADMIN + `search/dealerNumberSearch?searchText=${e}`,
      requestOptions
    )
      .then((response) => {
        const dealerSearchDataData =
          response.data &&
          response.data.data &&
          response.data.data.length &&
          response.data.data.map((dealerItem) => {
            return {
              label: dealerItem,
              value: dealerItem,
            };
          });
        setCustomerNumber(dealerSearchDataData);
      })
      .catch((error) => {});
  };

  const getSubdealer = (e) => {
    const requestOptions = {
      headers: {
        "Content-Type": "application/json",
        "X-AUTH-TOKEN": localStorage.getItem("x-auth-token"),
      },
    };
    Axios.get(
      API_URL_ADMIN + `search/subdealerNumberSearch?searchText=${e}`,
      requestOptions
    )
      .then((response) => {
        const subDealerSearchData =
          response.data &&
          response.data.data &&
          response.data.data.length &&
          response.data.data.map((dealerItem) => {
            return {
              label: dealerItem,
              value: dealerItem,
            };
          });
        setCustomerNumber(subDealerSearchData);
      })
      .catch((error) => {});
  };

  useEffect(() => {
    setCustomerTypeErr(false);
    setCustomerNumber([]);
    setFilterObj({ ...filterObj, customerNumber: "" });
  }, [filterObj.customerType]);

  React.useEffect(() => {
    const url = `mds/audit-event/create`;
    let details = {
      eventType: "Report_Visit",
      source: "Dealer And Subdealer Point Report",
      userId: (localStorage.getItem('userData') && JSON.parse(localStorage.getItem('userData')).userId) ?
        JSON.parse(localStorage.getItem('userData')).userId : '',
      customer_number: '',
    };

    Axios({
      method: "POST",
      url: API_URL_USER + url,
      data: details,
      headers: {
        "Content-Type": "application/json",
        "X-AUTH-TOKEN": localStorage.getItem("x-auth-token"),
        "X-SOLD-TO-ID": localStorage.getItem("CustomerNumber"),
      },
    })
      .then(async (response) => {
      })
      .catch((err) => {
      });
  }, [])

  function modifyColumns(columns) {
    columns = columns.filter((item) => !["actions", "aDate", "lDate", "p"].includes(item.field))
    return columns.map((item) => {
      return ({
        label: item.headerName,
        value: item.field,
        ...item
      })
    })
  }

  function modifyRows(rowdata) {
    // let filteredRow = searchedRows.map((item) => item.model);
    let filteredRow = rowdata.map((item) => item.model);
    const data = filteredRow.map((item) => {
      return ({
        ...item,
        // creationDate : item.creationDate ? new Date(item.creationDate) :""
      })
    })
    return data
  }

  function callExcelExport(data){
    const fileName = `Dealer_SubDealer_Points_Report_${moment(new Date()).format("DDMMyyyy")}`
    const sheetName = `Dealer_SubDealer_Points_Report_`
    onExportExcel(modifyColumns(columns), modifyRows(data), fileName,sheetName)
  }

  return (
    <>
      <div className={classes.root}>
        <Paper className={classes.paper}>
          <div className="myFirstT">
            {/* Filter And Searching Components here */}

            <div className="pCalFormControll">
              <Grid container spacing={2} columns={10}>
                <Grid item sm={5} md={3} xs={12}>
                  <Controls.Select
                    name="customerType"
                    label="Type of customer"
                    value={filterObj && filterObj.customerType}
                    onChange={filterOnChange}
                    options={CUSTOMER_LIST}
                    minWidth="100%"
                    // showSelect
                  />
                </Grid>

                <Grid item sx={{ marginTop: "-6px" }} sm={5} md={3} xs={12}>
                  <Controls.Input
                    name="customerNumber"
                    label={CUSTOMER_NUMBER}
                    value={values.customerNumber}
                    onChange={handleInputChange}
                    size="small"
                    variant="standard"
                  />
                </Grid>

                <Grid item sm={5} md={3} xs={12} className="AutoComplete">
                  <MultipleSelectCheckmarks />
                </Grid>

                <Grid item sm={5} md={3} xs={12}>
                  <Controls.DatePicker
                    name="startDate"
                    label="Last Point Created Date From"
                    value={
                      filterObj && filterObj.startDate
                        ? filterObj.startDate
                        : DATE_ONE_YEAR_BACK
                    }
                    maxDate={new Date()}
                    onChange={filterOnChange}
                    style={{ width: "100%" }}
                    error={filterErr.startDate}
                  />
                </Grid>
                <Grid item sm={5} md={3} xs={12}>
                  <Controls.DatePicker
                    name="endDate"
                    label="Last Point Created Date To"
                    maxDate={new Date()}
                    value={
                      filterObj && filterObj.endDate
                        ? filterObj.endDate
                        : new Date()
                    }
                    onChange={filterOnChange}
                    style={{ width: "100%" }}
                  />
                </Grid>

                <Grid item md xs display="flex" justifyContent="flex-end">
                  <Button
                    variant="contained"
                    className="btncolor"
                    size="small"
                    sx={{ m: 1 }}
                    onClick={onFilterSearch}
                  >
                    Search
                  </Button>
                  <Button
                    variant="outlined"
                    color="secondary"
                    className="outlineButton"
                    size="small"
                    sx={{ m: 1 }}
                    onClick={clearAll}
                  >
                    Clear All
                  </Button>
                </Grid>
              </Grid>
            </div>

            <div className="DataGridContainer">
              <ExportExcelPopup
                title={"Customer"}
                fileName={"customer"}
                setOpen={setOpen}
                open={open}
                exportExcelFile={exportExcelFile}
                fileUrl={fileUrl}
                exportFiles={exportFiles}
              />
              <DataGridProMUI
                rows={gridData}
                columns={columns}
                onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                pageSize={pageSize}
                loading={showLoading}
                onExportClick={onExportClick}
                exportState={exportState}
                setSearchedRows={setSearchedRows}
                callExcelExport={callExcelExport}
                defaultStateChange={false}
              />
            </div>
          </div>
        </Paper>
      </div>
    </>
  );
};

export default DealerAndSubdealerPoints;
